
import React from 'react';
import { DiagnosticResult } from './types';

interface SampleConnectionsSectionProps {
  results: DiagnosticResult;
}

export const SampleConnectionsSection: React.FC<SampleConnectionsSectionProps> = ({ results }) => {
  return (
    <div className="bg-muted p-4 rounded-md">
      <h3 className="font-medium mb-2">Sample Connections</h3>
      <div className="text-sm">
        {results.sample_connections.length > 0 ? (
          <pre className="bg-background p-2 rounded text-xs overflow-auto max-h-40">
            {JSON.stringify(results.sample_connections, null, 2)}
          </pre>
        ) : (
          <p className="text-red-500">No connections accessible to current user</p>
        )}
      </div>
    </div>
  );
};
